const dehyphenate = (val: string): string => {
  return val ? val.replace(/-/g, '') : val
}

export default dehyphenate
